<script setup lang="ts">
defineProps<{
  title: string
  hint?: string
}>()
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-2.5 px-6 py-16 text-center">
    <span
      class="mb-1 flex size-11 items-center justify-center rounded-full border border-dashed border-line-strong bg-raised text-[13px] font-semibold text-dim"
      aria-hidden="true"
    >
      —
    </span>
    <p class="text-[14px] font-medium text-muted">{{ title }}</p>
    <p v-if="hint" class="max-w-md text-[12.5px] leading-relaxed text-dim">{{ hint }}</p>
    <div v-if="$slots.action" class="mt-2">
      <slot name="action" />
    </div>
  </div>
</template>
